<template>
  <SubLayout
      :pageTitle="title"
      :pageBreadcrumbs="breadcrumbs"
      :hasBack="false"
  >

    <template #layoutContent>

      <Card :title="$t('prospect.list')" containerClass="mb-5 mt-5">

        <template #cardBody>
          <table class="table align-middle table-row-bordered fs-6 gy-3 gx-4"
                 id="customer_datatable">
            <thead class="mb-5">
            <tr class="fw-bold fs-6" style="background-color: #F2F3F4;">
              <th class=" text-start">{{ $t("contacts.lastname") }} & {{ $t("contacts.firstname") }}</th>
              <th class="text-start">{{ $t('contacts.email') }} </th>
              <th class="text-start">{{ $t('contacts.phone')}}</th>
              <th class="text-start">{{ $t("contacts.birthday") }}</th>
              <th class="text-start">{{ $t("contacts.website") }}</th>
              <th class="w-100px text-start">{{ $t('label.action') }}</th>
            </tr>
            </thead>
          </table>
        </template>
      </Card>
    </template>
  </SubLayout>
</template>

<script setup>

import {computed, nextTick, onMounted, onUpdated, ref, watch} from "vue";
import SubLayout from "@/views/Layouts/partials/SubLayout.vue";
import {useStore} from "vuex";
import i18n from "@/plugins/i18n";
import Ls from "@/services/ls";
import {BASE_URL} from "@/services/api";
import {useRouter} from "vue-router";
import {useLocales} from "@/composables/locales";
import {useHasAbility} from "@/composables/hasAbility";
import Card from "@/Modules/CRM/components/Card";
import {useSwal} from "@/composables/useSwal";
import { Theme } from "@/composables/theming";
import abilities from "@/composables/abilities";


const router = useRouter()
const store = useStore()
const { can } = useHasAbility()
const {locale, datatableLocaleUrl} = useLocales()

const {showSwal} = useSwal()
const title = ref("breadcrumbs.customer.title")
const breadcrumbs = ref([
  {
    name: 'breadcrumbs.customer.list',
    route: 'customer'
  }
])

const table = ref()



watch(() => locale.value, (value) => {
  nextTick(() => fetchDatas())
}, { deep: true })

function fetchDatas() {
  const AUTH_TOKEN = Ls.get('auth.token')
  const pageLimit = Ls.get('pageLength')

  table.value = $("#customer_datatable").DataTable({
    destroy: true,
    responsive: !0,
    searchDelay: 500,
    processing: !0,
    serverSide: !0,
    pageLength: pageLimit ||  5,
    lengthMenu: [5, 10, 25, 50, 75, 100 ],
    order: [[ 1, 'desc']],
    ajax: {
      url: BASE_URL + "/get/customer/datatables",
      type: "GET",
      beforeSend: function (request, options) {
        request.setRequestHeader("Authorization", "Bearer " + AUTH_TOKEN);
        request.setRequestHeader("Company", Ls.get('current.company'));
      }
    },
    columns: [
      { data: "fullname" },{ data: "email" }, { data: "phone" },{ data: "birth" },{ data: "website" },  { data: "Actions", responsivePriority: -1 }
    ],
    columnDefs: [
      {
        targets: -6,
        order: "desc",
        className: "dt-start text-start clickable" ,
        render: function (t, a, e, l) {
          let icon = e.contactType == "particular" ? 'fas fa-user' : 'fas fa-building'
          return '<span data-id="'+ e.id +'"> <i  class="me-3 '+icon+'" style="color: '+Theme.orange+';"></i>' 
          
          + t + "</span>";
        },
      },
      {
        targets: -5,
        order: "desc",
        className: "dt-start text-start clickable",
        render: function (t, a, e, l) {
          
          return '<span data-id="'+ e.id +'">' + t + "</span>";
        },
      },
      {
        targets: -4,
        order: "desc",
        className: "dt-start text-start clickable",
        render: function (t, a, e, l) {
          let phone = JSON.parse(t)
          return '<span data-id="'+ e.id +'">' + phone?.toString() + "</span>";
        },
      },
      {
        targets: -3,
        order: "desc",
        className: "dt-start text-start clickable",
        render: function (t, a, e, l) {
          
          return '<span data-id="'+ e.id +'">' + t + "</span>";
        },
      },
      {
        targets: -2,
        order: "desc",
        className: "dt-start text-start clickable" ,
        render: function (t, a, e, l) {
          return '<span data-id="'+ e.id +'">' + t + "</span>";
        },
      },

     
      {
        width: "15%",
        targets: -1,
        "className": "dt-center text-start",
        title: "Actions",
        orderable: !1,
        render: (t, a, e, l) => { 
          let render=""
          if (can(abilities.VALIDATE_PROSPECT)) {
            render += `
        <a href="javascript:;" data-id="${e.id}" class="btn btn-sm btn-icon validate_btn"
            title="${i18n.global.t('button.validate')}" style="color: ${Theme.gray}">
            <i data-id="${e.id}" class="bi bi-check2 fs-1"></i>
        </a>
    `;
          }

          if (can(abilities.REJECT_PROSPECT)) {
            render += `
        <a href="javascript:;" data-id="${e.id}" class="btn btn-sm btn-clean btn-icon reject_btn"
            title="${i18n.global.t('button.reject')}" style="color: ${Theme.gray}">
            <i data-id="${e.id}" class="bi bi-x fs-2"></i>
        </a>
    `;
          }
          return render
        },
      },

    ],
    language: {
      url: datatableLocaleUrl.value,
    }
  });

}


$(document).on("click", "#customer_datatable .reject_btn", (e) => {
  rejectCustomerAccount(e.target.getAttribute('data-id'))
});

$(document).on("click", "#customer_datatable .validate_btn", (e) => {
  validateCustomerAccount(e.target.getAttribute('data-id'))
});


function validateCustomerAccount(id){
  showSwal(
      i18n.global.t('prospect.swal.validate_account'),
      i18n.global.t('prospect.swal.validate_text')
  ).then( async (result) => {
    if (result.value) {
      store.dispatch('customer/validateCustomerAccount', id)
          .then(() => {
            window.toastr['success'](i18n.global.t('prospect.notification.customer_validate'))
            table.value.ajax.reload()
            closeModal()

          })
          .catch(() => {

          })
    }
  })
}

function rejectCustomerAccount(id){
  showSwal(
      i18n.global.t('prospect.swal.reject_account'),
      i18n.global.t('prospect.swal.reject_text')
  ).then( async (result) => {
    if (result.value) {
      store.dispatch('customer/rejectCustomerAccount', id)
          .then(() => {
            window.toastr['success'](i18n.global.t('prospect.notification.customer_reject'))
            table.value.ajax.reload()
            closeModal()
          })
          .catch(() => {

          })
    }
  })
}



function loadData() {
  fetchDatas()
}

onMounted( () => {
  loadData()
})


</script>

<style scoped>

</style>